import './popinParticipants.css';

const kidsAgesViewModule = () => import(/* webpackChunkName: 'components/search/kidsAgesView' */'../searchForm/participants/kidsAge/kidsAge');

import { MainEngineModel } from '../searchElastic/searchElasticModel';
import { generateAddToCartTrackingDatasFromBtnDataAttr } from '../tracking/_generateAddToCartTrackingDatasFromBtnDataAttr';
import { BookingForm } from '../bookingForm/bookingForm';

export const PopinParticipantsView = Backbone.View.extend({
  events: {
    'click .js_popinParticipantsSubmit': 'submit'
  },

  initialize: function (options = {}) {
    this.nbAdults = 0;
    this.nbChildren = 0;
    this.nbBabies = 0;
    this.maxKids = 0;
    this.nbPets = 0;
    this.maxCapacity = 0;
    this.maxChildren = 0;
    this.maxBabies = 0;
    this.maxPets = 0;
    this.fullCapacity = false;
    this.fullChildren = false;
    this.fullBabies = false;
    this.fullPets = false;
    this.firstOpening = true;
    this.addToCartTrackingDatas = {};
    this.isReset = typeof options.reset !== 'undefined' ? options.reset : false;
    this.wordingSearch = SEARCH_SCRIPTS.WORDING_SEARCH;
    this.$bookingLink = $();

    this.initPopinParticipants();
    this.model = typeof options.model !== 'undefined' ? options.model : new MainEngineModel(true);

    kidsAgesViewModule().then(({KidsAgesView}) => {
      const kidsAgeOptions = {
        viewElement: '#js-popinParticipantsForm',
        inputChildrenSelector: '#js-popinParticipants-childrenNumber',
        triggerPrefix: 'popinParticipants',
        prefix: 'popinParticipants_',
        model: this.model
      };

      this.KidsAgesView = new KidsAgesView(kidsAgeOptions);
    });

    this.stopListening(dispatcher, 'popinParticipants:init');
    this.listenTo(dispatcher, 'popinParticipants:init', this.initPopinParticipants);

    this.stopListening(dispatcher, 'popinParticipants:handleParticipantsDisplay');
    this.listenTo(dispatcher, 'popinParticipants:handleParticipantsDisplay', this.handleParticipantsDisplay);

    this.stopListening(dispatcher, 'popinParticipants:openFancyIframe');
    this.listenTo(dispatcher, 'popinParticipants:openFancyIframe', this.openFancyIframe);

    this.stopListening(dispatcher, 'popinParticipants:closeFancyIframe');
    this.listenTo(dispatcher, 'popinParticipants:closeFancyIframe', this.closeFancyIframe);

    this.stopListening(dispatcher, 'popinParticipants:updateModel');
    this.listenTo(dispatcher, 'popinParticipants:updateModel', this.updateModel);
  },

  initListeners() {
    $('.js-formQuantityAdd').off('click').on('click', event => {
      if (this.fullCapacity || this.fullAdult || this.fullBabies || this.fullPets || this.fullChildren) {
        this.handleErrorMsg(event);
      }
    });

    $('.js_popinParticipantsSubmit').off('click').on('click', event => {
      this.submit(event);
    });

    this.initSelectorQuantity();
  },

  //instanciation de la fancybox
  initPopinParticipants() {
    $('.js-fancybox-popinParticipants').off('click').on('click', event => {
      this.setDefaultData(event);
    });

    let optionsData = {baseClass: 'fancybox-popinParticipants'};
    if ($('#js-iframeLightCottageDetails').length) {
      optionsData.beforeShow = this.openFancyIframe;
      optionsData.beforeClose = this.closeFancyIframe;
    }

    const fancyParam = {
      selector: '.js-fancybox-popinParticipants',
      popinName: 'popinParticipants',
      fancyType: 'custom',
      options: optionsData
    };

    new FancyboxView(fancyParam);
  },

  //instanciation des valeurs affichées et à utiliser
  setDefaultData(event) {
    const $currentTarget = $(event.currentTarget);

    if (GLOBAL_SCRIPTS.TRACKING_ENABLED) {
      this.addToCartTrackingDatas = generateAddToCartTrackingDatasFromBtnDataAttr($currentTarget);
    }

    this.$bookingLink = $currentTarget;
    this.maxCapacity = parseInt($currentTarget.attr('data-maxcapacity'));
    this.maxBabies = Number.isInteger(parseInt($currentTarget.attr('data-maxbabies'))) ? parseInt($currentTarget.attr('data-maxbabies')) : 0;
    this.maxChildren = Number.isInteger(parseInt($currentTarget.attr('data-maxchildren'))) ? parseInt($currentTarget.attr('data-maxchildren')) : 0;
    this.maxKids = this.maxBabies + this.maxChildren;
    this.maxAdults = parseInt($currentTarget.attr('data-maxadults'));
    this.maxPets = parseInt($currentTarget.attr('data-maxpets'));
    this.nbSeniors = 0;
    this.nbChildren = 0;
    this.nbPets = 0;
    this.nbAdults = 2;
    this.ages = [];
    this.fullAdult = false;
    this.fullChildren = false;
    this.fullPets = false;
    this.nbSelectAgeOpened = 0;

    //update participants rules
    this.participantsRules = {
      adults: {
        default: this.nbAdults,
        max: this.maxCapacity,
        min: 0
      },
      seniors: {
        default: 0,
        max: this.maxCapacity,
        min: 0
      },
      children: {
        default: 0,
        max: this.maxChildren,
        min: 0
      },
      babies: {
        default: 0,
        max: this.maxBabies,
        min: 0
      },
      pets: {
        default: 0,
        max: this.maxPets,
        min: 0
      },
      ages: {
        default: []
      },
      values: [],
      maxParticipants: this.maxCapacity + this.maxBabies//le nombre max de participants affiché est différent du nombre max de place dispo, car les bébés ne prennent pas de place
    };

    const defaultValues = {
      participantsRules: this.participantsRules,
      multiparticipants: [{
        adults: this.nbAdults,
        seniors: 0,
        children: 0,
        pets: 0,
        ages: []
      }, {
        adults: 0,
        seniors: 0,
        pets: 0,
        ages: []
      }]
    };

    this.model.set(defaultValues, {'silent': true});
    dispatcher.trigger('popinParticipants_kidsAges:render', 'kids', 0);

    if (this.maxChildren === 0 && this.maxBabies) {
      $('#popinParticipants-children').parent().addClass('u-Hidden');
    } else {
      $('#popinParticipants-children').parent().removeClass('u-Hidden');
    }
    if (this.maxPets === 0) {
      $('#popinParticipants-pets').parent().addClass('u-Hidden');
    } else {
      $('#popinParticipants-pets').parent().removeClass('u-Hidden');
    }

    //handling description content
    const baseDescription = typeof this.wordingSearch['popinParticipants_description'] !== 'undefined' ? this.wordingSearch['popinParticipants_description'].replace('%XX', this.maxCapacity) : '';
    const baby = typeof this.wordingSearch['popinParticipants_baby_singular'] !== 'undefined' ? this.wordingSearch['popinParticipants_baby_singular'] : ' ';
    const babies = typeof this.wordingSearch['popinParticipants_baby_plural'] !== 'undefined' ? this.wordingSearch['popinParticipants_baby_plural'] : ' ';
    const pet = typeof this.wordingSearch['popinParticipants_pet_singular'] !== 'undefined' ? this.wordingSearch['popinParticipants_pet_singular'] : ' ';
    const pets = typeof this.wordingSearch['popinParticipants_pet_plural'] !== 'undefined' ? this.wordingSearch['popinParticipants_pet_plural'] : ' ';
    const htmlBaby = this.maxBabies === 0 ? '' : this.maxBabies > 1 ? babies.replace('%XX', this.maxBabies) : baby;
    const htmlPets = this.maxPets === 0 ? '' : this.maxPets > 1 ? pets.replace('%XX', this.maxPets) : pet;
    const comma_1 = this.maxBabies > 0 && this.maxPets > 0 ? ', ' : ' ';
    const comma_2 = this.maxBabies === 0 || this.maxPets === 0 ? ', ' : ' ';
    const noBaby = this.maxBabies === 0 && this.maxPets > 0 ? this.wordingSearch['popinParticipants_no_babies'] : ' ';
    const noPets = this.maxBabies > 0 && this.maxPets === 0 ? this.wordingSearch['popinParticipants_no_pets'] : ' ';
    const noBabyPets = this.maxBabies === 0 && this.maxPets === 0 ? this.wordingSearch['popinParticipants_no_babies_no_pets'] : '';
    const htmlDescription = baseDescription + comma_1 + htmlBaby + ' ' + htmlPets + comma_2 + noBaby + noPets + noBabyPets;

    //init participants values
    $('#js-popinParticipants-seniorNumber').val(this.nbSeniors);
    $('#js-popinParticipants-adultNumber').val(this.nbAdults);
    $('#js-popinParticipants-childrenNumber').val(this.nbChildren);
    $('#js-popinParticipants-petsNumber').val(this.nbPets);
    $('#js-popinParticipants-description').html(htmlDescription);

    if (this.firstOpening) {
      this.initListeners();
      this.firstOpening = false;
    }

    this.initSelectorQuantity();
    this.handleParticipantsDisplay();

    Tracking.dataLayerPush({
      popinName: 'Checkout Participants',
      popinContainsFormInfos: false,
      popinContainsCheckoutInfos: true,
      checkoutStepsPath: 1,
      checkoutStepNumber: 1,
      checkoutStepName: 'Participants',
      checkoutStepType: 'STAY',
      checkoutOldStepNumber: 1,
      checkoutOldStepName: 'Booking Funnel step 1 - participants',
      event: 'popinDisplay'
    });
  },

  getData() {
    this.nbSeniors = this.model.get('multiparticipants')[0].seniors;
    this.nbAdults = this.model.get('multiparticipants')[0].adults;
    this.nbChildren = this.model.get('multiparticipants')[0].ages.length;
    this.ages = this.model.get('multiparticipants')[0].ages;
    this.nbPets = this.model.get('multiparticipants')[0].pets;
  },

  //instanciation des sélecteurs de participants
  initSelectorQuantity() {
    new Form.QuantitySelectorView({
      element: $('#popinParticipants-seniors'),
      rules: {
        min: 0,
        max: this.maxCapacity,
        useSelectorDefaultCheck: false
      },
      addCallBack: 'popinParticipants:updateModel',
      removeCallBack: 'popinParticipants:updateModel',
      identifier: 'seniors'
    });

    new Form.QuantitySelectorView({
      element: $('#popinParticipants-adults'),
      rules: {
        min: 0,
        max: this.maxCapacity,
        useSelectorDefaultCheck: false
      },
      addCallBack: 'popinParticipants:updateModel',
      removeCallBack: 'popinParticipants:updateModel',
      identifier: 'adults'
    });

    new Form.QuantitySelectorView({
      element: $('#popinParticipants-children'),
      rules: {
        min: 0,
        max: this.maxKids,
        useSelectorDefaultCheck: false
      },
      addCallBack: 'popinParticipants:updateModel',
      removeCallBack: 'popinParticipants:updateModel',
      identifier: 'kids'
    });

    new Form.QuantitySelectorView({
      element: $('#popinParticipants-pets'),
      rules: {
        min: 0,
        max: this.maxPets,
        useSelectorDefaultCheck: false
      },
      addCallBack: 'popinParticipants:updateModel',
      removeCallBack: 'popinParticipants:updateModel',
      identifier: 'pets'
    });
  },

  //la mise à jour du model
  updateModel: function (identifier, quantity) {
    const multiparticipants = this.model.get('multiparticipants') || [];

    this.lastParticipantsModified = identifier;
    multiparticipants[0][identifier] = quantity;
    this.model.set('multiparticipants', multiparticipants);
    this.handleParticipantsDisplay();

    if (identifier === 'kids') {
      dispatcher.trigger('popinParticipants_kidsAges:render', identifier, quantity);
    }
  },

  //gestion de l'activation/desactivation des boutons -/+ des sélecteurs
  handleParticipantsDisplay: function () {
    this.getData();

    $('.form-quantityErrorMessage').removeClass('display-alertError');

    const $seniorElement = $('#popinParticipants-seniors');
    const $adultElement = $('#popinParticipants-adults');
    const $childElement = $('#popinParticipants-children');
    const $petElement = $('#popinParticipants-pets');
    const nbAdults = this.nbAdults;
    const nbSeniors = this.nbSeniors;
    const nbPets = this.nbPets;
    const disableClass = 'u-disabled';
    const formQtyRemoverSelector = '.form-QuantityRemover';
    const formQtyAdderSelector = '.form-QuantityAdder';
    const formQtyValueSelector = '.js-formQuantityValue';
    const $childrenInput = $childElement.find(formQtyValueSelector);
    const maxMinors = this.maxKids;
    const nbGrownUp = nbAdults + nbSeniors;
    const maxParticipants = this.maxCapacity + this.maxBabies;
    const nbChildren = parseInt($($childrenInput).val());
    const $kidsAgeContainer = $('#js-popinParticipantsForm .js-selectKidAge-container');
    const nbTotal = parseInt(nbGrownUp + nbChildren);

    //Handling GrownUps (adults + seniors)
    //Note: le nombre maximum d'adultes dépend du nombre de bébés sélectionnés
    this.nbSelectAgeOpened = this.model.get('multiparticipants')[0].kids;
    this.fullAdult = nbTotal >= maxParticipants || nbGrownUp >= (this.maxCapacity - nbChildren + $kidsAgeContainer.filter('.isBaby').length);
    $adultElement.find(formQtyAdderSelector).add($seniorElement.find(formQtyAdderSelector)).toggleClass(disableClass, this.fullAdult);

    //Handling capacity
    this.fullCapacity = nbTotal >= maxParticipants;

    //Handling adults
    $adultElement.find(formQtyRemoverSelector).toggleClass(disableClass, !nbGrownUp || !nbAdults);
    $adultElement.find(formQtyValueSelector).toggleClass(disableClass, !nbAdults);

    //Handling seniors
    $seniorElement.find(formQtyRemoverSelector).toggleClass(disableClass, !nbGrownUp || !nbSeniors);
    $seniorElement.find(formQtyValueSelector).toggleClass(disableClass, !nbSeniors);

    //Handling children
    this.fullChildren = nbTotal >= maxParticipants || nbChildren >= maxParticipants - nbGrownUp || nbChildren >= maxMinors;
    $childElement.find(formQtyRemoverSelector).add($childrenInput).toggleClass(disableClass, !nbChildren);
    $childElement.find(formQtyAdderSelector).toggleClass(disableClass, this.fullChildren);

    //Handling pets
    this.fullPets = nbPets === this.maxPets;
    $petElement.find(formQtyRemoverSelector).add($petElement.find(formQtyValueSelector)).toggleClass(disableClass, !nbPets);
    $petElement.find(formQtyAdderSelector).toggleClass(disableClass, this.fullPets);

    //on vérifie le status des kids ages si une modification change un max
    dispatcher.trigger('popinParticipants_kidsAges:handleAgeSelectStatus');

    //verification de l'activation du bouton de submit par rapport aux kids ages vides
    $('.js_popinParticipantsSubmit').toggleClass(disableClass, !nbGrownUp || $kidsAgeContainer.filter(':not(.isKid):not(.isBaby)').length > 0);
  },

  //gestion de l'affichage des messages d'alertes lorsque les maximums sont atteints
  handleErrorMsg(event) {
    const $currentTarget = $(event.currentTarget);

    $('.form-quantityErrorMessage').removeClass('display-alertError');

    if ($currentTarget.parents('#popinParticipants-adults').length && this.fullAdult) {
      $('#popinParticipants-adults .form-quantityErrorMessage').addClass('display-alertError');
    } else if ($currentTarget.parents('#popinParticipants-seniors').length && this.fullAdult) {
      $('#popinParticipants-seniors .form-quantityErrorMessage').addClass('display-alertError');
    } else if ($currentTarget.parents('#popinParticipants-children').length && this.fullChildren) {
      $('#popinParticipants-children .js-formQuantity-errorMessage2').addClass('display-alertError');
    } else if ($currentTarget.parents('#popinParticipants-children').length && this.fullCapacity) {
      $('#popinParticipants-children .js-formQuantity-errorMessage').addClass('display-alertError');
    } else if ($currentTarget.parents('#popinParticipants-pets').length && this.fullPets) {
      $('#popinParticipants-pets .form-quantityErrorMessage').addClass('display-alertError');
    }
  },

  //-- handle iframe light cottage details
  openFancyIframe() {
    $('.fancybox-slide--iframe', window.parent.document).addClass('hasDoubleFancybox');
  },

  //-- iframe light cottage details
  closeFancyIframe() {
    $('.fancybox-slide--iframe', window.parent.document).removeClass('hasDoubleFancybox');
  },

  submit(event) {
    event.preventDefault();

    // Handling stored search parameters
    // Rule : if participants = default participants => on efface la valeur participants du cookie. Dans le cas contraire, on les mémorise
    const isDefaultValues = this.nbAdults === 2 && this.ages.length === 0 && this.nbPets === 0;

    let oParticipants = null;

    this.getData();

    // Handling stored search parameters
    if (!isDefaultValues) {
      let storedAges = [];

      $.each($('#js-popinParticipantsForm .js-selectKidAge'), (_key, item) => {
        if ($(item).val()) {
          const val = parseInt($(item).val());

          storedAges.push({
            key: val,
            value: val
          });
        }
      });

      oParticipants = [{
        senior: {
          key: this.nbSeniors,
          value: this.nbSeniors
        },
        adult: {
          key: this.nbAdults,
          value: this.nbAdults
        },
        pet: {
          key: this.nbPets,
          value: this.nbPets
        },
        ages: storedAges
      }];
    }

    dispatcher.trigger('search:updateMainSearchStore', 'multiparticipants', oParticipants, true);

    if (typeof window.location.search !== 'undefined') {
      if (window.location.search.length) {
        const arrCouples = window.location.search.slice(window.location.search.indexOf('?') + 1).replace(/&amp;/g, '&').replace(/%5B/g, '[').replace(/%5D/g, ']').split('&');
        //création d'un tableau avec tous les paramètres
        const isFlexModal = $('html').hasClass('flexModal-active');
        const $flexModalSubmitBtn = $('.js-flexModal .js-fancybox-popinParticipants');

        //Si l'utilisateur a touché aux filtres = qu'il dispose de paramètres query dans son url, alors on updateCurrentUri
        let dataToReplace = {};

        $(arrCouples).each((_idx, item) => {
          const couple = item.split('=');

          if (isFlexModal && couple[0] === 'facet[DATE]') {
            dataToReplace[couple[0]] = $flexModalSubmitBtn.attr('data-start');
          } else if (isFlexModal && couple[0] === 'facet[DATEEND]') {
            dataToReplace[couple[0]] = $flexModalSubmitBtn.attr('data-end');
          } else if (couple[0] === 'facet[MULTIPARTICIPANTS][0][senior]') {
            dataToReplace[couple[0]] = $('#js-popinParticipants-seniorNumber').val();
          } else if (couple[0] === 'facet[MULTIPARTICIPANTS][0][adult]') {
            dataToReplace[couple[0]] = $('#js-popinParticipants-adultNumber').val();
          } else if (couple[0] === 'facet[MULTIPARTICIPANTS][0][pet]') {
            dataToReplace[couple[0]] = $('#js-popinParticipants-petsNumber').val();
          } else {
            dataToReplace[couple[0]] = couple[1];
          }
        });

        dispatcher.trigger('postParams:updateCurrentUri', false, dataToReplace);
      } else {
        dispatcher.trigger('postParams:initBackNav');
      }
    } else {
      dispatcher.trigger('postParams:initBackNav');
    }

    if (GLOBAL_SCRIPTS.TRACKING_ENABLED) {
      /** Mise à jour des infos liés aux participants avant de déclencher l'event de tracking add_to_cart */
      this.addToCartTrackingDatas.ecommerce.items[0].item_booking_adults_number = this.nbAdults;
      this.addToCartTrackingDatas.ecommerce.items[0].item_booking_children_number = this.ages.length;
      this.addToCartTrackingDatas.ecommerce.items[0].item_booking_seniors_number = this.nbSeniors;
      this.addToCartTrackingDatas.ecommerce.items[0].item_booking_guests_number = this.nbAdults + this.nbSeniors + this.ages.length;
      this.addToCartTrackingDatas.ecommerce.items[0].item_booking_pets_number = this.nbPets;
      this.addToCartTrackingDatas.ecommerce.items[0].item_booking_children_age = this.ages.length > 0 ? JSON.stringify(this.ages) : '[]';
      this.addToCartTrackingDatas.click_code = 'clickCheckoutNextStep';
      this.addToCartTrackingDatas.ga_action = 'Go to next step';
      this.addToCartTrackingDatas.ga_label = this.wordingSearch.popinParticipants_validate;
      Tracking.dataLayerPush(this.addToCartTrackingDatas);
    }

    // Update participants and go to resa
    this.$bookingLink.data('seniorsnb', this.nbSeniors);
    this.$bookingLink.data('adultsnb', this.nbAdults);
    this.$bookingLink.data('childrennb', this.ages.length);
    this.$bookingLink.data('ages', this.ages);
    this.$bookingLink.data('petsnb', this.nbPets);

    const bookingForm = new BookingForm();
    bookingForm.submitBooking(this.$bookingLink);
  }
});